import websiteDe from '$lib/i18n/locales/de/websiteDe.json';
import shopDe from '$lib/i18n/locales/de/shopDe.json';
import dataTableDe from '$lib/i18n/locales/de/dataTableDe.json';
import errorDe from '$lib/i18n/locales/de/errorDe.json';

export default {
    localeName: 'Deutsch',
    localeIdentifier: 'de-DE',
    website: websiteDe,
    shop: shopDe,
    error: errorDe,
    ...dataTableDe
};
